module.exports = {
  Environment: "Production",
  // API_ENDPOINT: "https://demo-trackunit-gw.incus5.com/deployment/v1.0",
  // API_ENDPOINT: "https://trackunit-gw.incus5.com/deployment/v1.0",
  ENABLE_ACCESS_CODE: false,
  ENABLE_TRIPS: true,
  ENABLE_MAP_TELEMATICS: false,
  API_ENDPOINT: "https://maxx-gw.birchequipment.com/user/v1.0/",
  ALERT_CONFIG_ENDPOINT: "https://maxx-gw.birchequipment.com/alerts/v1.0/",

  SMS_ENDPOINT: "https://api.birchequipment.com/",
  SMS_ENDPOINT_NEW: "https://maxx-gw.birchequipment.com/sms/v1.0/",
  TELEMATICS_ENDPOINT: "https://maxx-gw.birchequipment.com/telematics/v1.0/",
  LOCATION_ENDPOINT: "https://maxx-gw.birchequipment.com/cp/location/v1.0/",
  GOOGLE_MAPS: "https://maps.googleapis.com/maps/api/",
  GOOGLE_MAPS_API: "AIzaSyDq4l0RcyWsyNY5dui__Dxp1MEF2-iGfc0",
  // actual access token expiry time is 60 min, hence refreshing the access token at 58 min
  AUTH_TOKEN_INTERVAL: 3480000,
  NOTIFICATION_REFRESH_INTERVAL: 900000,
};
